/**
 * 服务端返回 Code 与业务匹配
 */
export const EResponseCode = {
  Success: 200,
  FAIL_201: -201,
  FAIL_202: -202,
  FAIL_301: -301,
  FAIL_501: -501,
  FAIL_502: -502,
  FAIL_503: -503,
  FAIL_504: -504,
  FAIL_505: -505,
  NO_PARAMS: -206, // 缺少参数, loginToken
  TOKEN_ERROR: -207, // token error
  USER_NO_EXIST: -208, // 当前用户不存在
  UNBOUND_SITE: -231, // 未绑定站点
  ACCESS_FORBIDDEN: 403, // 请求对应资源禁止被访问
  SERVER_ERROR: 500, // 服务器内部错误
  BingWorkNumber: -322, // 还没绑定工号
  CUSTOMER_PAY_ERROR: -235, // 渠道支付密码失败
  PASSWORD_ERROR: -236, // 密码错误
  XIAOHUI_ERROR: 1000, // 永辉金融-小辉付
  HOLDORDER_ERROR: -323, // 处理buyer/holdOrder接口，定制弹窗提示跳转购物车
  INCORRECT_PAY: -226, // 应付金额错误
  MallTYPE_TIME: -328, // 及时达 非营业时间不能下单
  STATION_DOWN: -241, // 首页站点下线
  // -300:您无权限访问此站点
  // -299:站点不支持微信支付
}
